import { render, staticRenderFns } from "./page-jobs.vue?vue&type=template&id=0fdab29f&"
import script from "./page-jobs.vue?vue&type=script&lang=js&"
export * from "./page-jobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports